import { redirect } from '@tanstack/react-router';
import { ensureMe } from './useMe.ts';

/** beforeLoad guard: redirect to phone login (with return path) when logged out. */
export async function requireAuth({ location }: { location: { href: string } }) {
  const me = await ensureMe();
  if (!me) throw redirect({ to: '/auth/phone', search: { redirect: location.href } });
}
